import colors from "core/resources/theme/colors";
import { Col, Row } from "antd";
import { Box, Flex } from "@chakra-ui/layout";
import { Text, Textarea, Checkbox } from "@chakra-ui/react";
import { useCurrentTenant } from "core/features/auth/tenant.store";
import { ReservaForm } from "core/features/reservas/typings";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "ui/components/Input/Field";
import SelectPessoas from "ui/components/Input/SelectPessoas";
import SelectUnidade from "ui/components/Input/SelectUnidade";
import SelectBlocoQuadra from "ui/components/Input/SelectBlocoQuadra";
import { TipoEstruturaMoradiaEnum } from "core/resources/enums/tenant";

function FormPersonalizar({
  control,
  form,
  onOpenTermos,
  setValue,
}: {
  control: Control<ReservaForm, object>;
  form: ReservaForm;
  onOpenTermos?: () => any;
  setValue: UseFormSetValue<ReservaForm>;
}) {
  const { tenant } = useCurrentTenant();

  return (
    <>
      <Text fontSize={"18px"} fontWeight={"bold"} mb="32px">
        Personalizar evento
      </Text>
      <Row gutter={24}>
        <Box as={Col} xs={12} mb={4}>
          <Field
            label="Nome do evento"
            control={control}
            name="nome"
            rules={{
              required: true,
            }}
          />
        </Box>
      </Row>

      <Row gutter={24}>
        {tenant.tipoEstruturaMoradia ? (
          <Box as={Col} xs={6} mb={4}>
            <Field
              label={
                tenant.tipoEstruturaMoradia === TipoEstruturaMoradiaEnum.Bloco
                  ? "Bloco"
                  : "Quadra"
              }
              control={control}
              name="blocoQuadraId"
              rules={{
                required: true,
              }}
              render={({ field, isInvalid }) => (
                <SelectBlocoQuadra
                  isInvalid={isInvalid}
                  {...field}
                  tenantId={tenant.id}
                />
              )}
            />
          </Box>
        ) : null}

        <Box as={Col} xs={tenant.tipoEstruturaMoradia ? 9 : 12} mb={4}>
          <Field
            label="Unidade"
            control={control}
            name="unidadeId"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <SelectUnidade
                isInvalid={isInvalid}
                value={field.value}
                onChange={(value, option) => {
                  field.onChange(value);
                  if (option) {
                    setValue(
                      "unidadeNumero",
                      (option as { label: string; value: string }).label
                    );
                  } else {
                    setValue("unidadeNumero", undefined);
                  }
                }}
                blocoQuadraId={form.blocoQuadraId}
                tenantId={tenant.id}
                allowClear
              />
            )}
          />
        </Box>
        {form.unidadeId ? (
          <Box as={Col} xs={tenant.tipoEstruturaMoradia ? 9 : 12} mb={4}>
            <Field
              label="Nome do responsavel"
              control={control}
              name="responsavelId"
              rules={{
                required: true,
              }}
              render={({ field, isInvalid }) => (
                <SelectPessoas
                  isInvalid={isInvalid}
                  onChange={(value, option) => {
                    field.onChange(value);
                    setValue(
                      "responsavelNome",
                      option
                        ? (option as { label: string; value: string }).label
                        : undefined
                    );
                  }}
                  value={field.value}
                  tenantId={null}
                  unidadeId={form.unidadeId}
                  tipoEntidades={[TipoEntidadeEnum.Condomino]}
                />
              )}
            />
          </Box>
        ) : null}
      </Row>

      <Row gutter={24}>
        <Box as={Col} xs={24}>
          <Field
            label="Anotações"
            control={control}
            name="observacao"
            render={({ field, isInvalid }) => (
              <Textarea
                isInvalid={isInvalid}
                className="chakra-input"
                rows={4}
                placeholder="Digite..."
                {...field}
              />
            )}
          />
        </Box>
      </Row>

      <Box mt={4}>
        <Field
          control={control}
          name="aceitoTermos"
          render={({ field, isInvalid }) => (
            <Flex alignItems="center">
              <Checkbox
                mr={2}
                isChecked={!!field.value}
                onChange={() => field.onChange(!field.value)}
                h="20px"
              />
              Li e aceito os
              <Text
                ml={1}
                as="a"
                color={colors.blue}
                cursor="pointer"
                onClick={onOpenTermos}
                _hover={{ opacity: 0.6 }}
              >
                Termos de Uso
              </Text>
            </Flex>
          )}
        />
      </Box>
    </>
  );
}

export default FormPersonalizar;
